import React, { useEffect, useState } from 'react';
import classes from './styles.module.scss';

const TimePicker = ({ value = '09:00', onChange }) => {
    const [hours, setHours] = useState('09');
    const [minutes, setMinutes] = useState('00');

    useEffect(() => {
        if (value && value.includes(':')) {
            const [h, m] = value.split(':');
            if (h && m) {
                setHours(h.padStart(2, '0'));
                setMinutes(m.padStart(2, '0'));
            }
        }
    }, [value]);

    const handleHoursChange = (e) => {
        const newHours = e.target.value.padStart(2, '0');
        setHours(newHours);
        onChange(`${newHours}:${minutes}`);
    };

    const handleMinutesChange = (e) => {
        const newMinutes = e.target.value.padStart(2, '0');
        setMinutes(newMinutes);
        onChange(`${hours}:${newMinutes}`);
    };

    return (
        <div className={classes.time_picker}>
            <select value={hours} onChange={handleHoursChange}>
                {Array.from({ length: 24 }, (_, i) => {
                    const val = i.toString().padStart(2, '0');
                    return (
                        <option key={val} value={val}>
                            {val}
                        </option>
                    );
                })}
            </select>
            <select value={minutes} onChange={handleMinutesChange}>
                {['00', '15', '30', '45'].map(min => (
                    <option key={min} value={min}>{min}</option>
                ))}
            </select>
        </div>
    );
};

export default TimePicker;
